import { render, staticRenderFns } from "./ShipmentPopupTemp.vue?vue&type=template&id=1bce50a6"
import script from "./ShipmentPopupTemp.vue?vue&type=script&lang=js"
export * from "./ShipmentPopupTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports